import { ITimetableSchedule } from 'src/api/getTimetable';
import { getEntityId, TimetableEntityRef, TimetableScheduleTrack } from './helpers';
import { reassignToDefault, RemoveScheduleResult } from './reassignToDefault';

/**
 * Builds the PATCH payload for removing every instance of one menu/menu set/price scheme from a
 * timetable: each (day, track) lane it appears in is resent with its slots handed to the
 * timetable's default entity - see reassignToDefault.
 */
export const removeEntityBlocks = (
  existingSchedules: ITimetableSchedule[],
  track: TimetableScheduleTrack,
  entityId: string,
  defaultEntity: TimetableEntityRef,
): RemoveScheduleResult =>
  reassignToDefault(existingSchedules, track, (schedule) => getEntityId(schedule) === entityId, defaultEntity);
